<h2 mat-dialog-title class="colorblue">{{ title }}</h2>

<mat-divider></mat-divider>

<mat-dialog-content class="mat-dialog-content" style="min-height: 350px">
  <mat-tab-group style="height: 300px" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="File">
      <div class="info">Select a .json file to import into a new edit form.</div>
      <div class="full-row">
        <div>
          <button
            mat-stroked-button
            class="button-select-file"
            (click)="openInput()"
          >
            Select File to Import
          </button>
        </div>
        <div class="file-name" [ngClass]="filename ? 'test' : 'italics'">
          {{ filename ? filename : "no file chosen" }}
        </div>
        <input
          id="fileInput"
          hidden
          type="file"
          (change)="uploadFile($event)"
          name="file1"
          accept=".json"
        />
      </div>
    </mat-tab>
    <mat-tab label="JSON">
      <div class="full-row-col" style="margin-top: 10px">
        <div style="width: 100%" class="padbottom20px">Paste JSON here:</div>
        <textarea
          class="bordergray"
          [(ngModel)]="pastedJSON"
          cdkAutosizeMinRows="8"
          (ngModelChange)="checkLoaded()"
          style="min-height: 180px"
        ></textarea>
      </div>
    </mat-tab>
    <mat-tab label="URL" *ngIf="urlImportEnabled">
      <div class="full-row-col" style="margin-top: 10px">
        <div style="width: 100%" class="padbottom20px">URL:</div>
        <input
          style="width: calc(100% - 10px)"
          placeholder="E.g. https://domain.com/substance.json"
          [(ngModel)]="pastedUrl"
          (ngModelChange)="checkUrl()"
        />
        <div style="width: 100%; margin-top: 5px; font-style: italic; font-size: 80%">
          Note: The URL needs to be publicly accessible
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="message" *ngIf="message">
    {{ message }}
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="mat-dialog-actions">
  <button mat-stroked-button class="button-cancel colorred" matDialogClose>
    Cancel
  </button>
  <span class="middle-fill"></span>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!loaded"
    (click)="importSubstance()"
  >
    Import
  </button>
</mat-dialog-actions>
